"use client";
import { useEffect } from "react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { Box, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { MAIN_ROUTES } from "@/constants/routes";
import { scrollToElement } from "@/utils/scrollToElement";
import { SIDEBAR_OPTIONS } from "./constants";

const PricingSidebar = () => {
  const searchParams = useSearchParams();
  const table = searchParams?.get("table");

  useEffect(() => {
    if (table) {
      scrollToElement(table as string, 120);
    }
  }, [table]);

  return (
    <Box
      bottom={0}
      boxShadow="0 10px 10px 0 rgba(0,0,0,.1)"
      position="fixed"
      pt={0}
      top={"78px"}
      mt={"20px"}
      width={{
        base: "0px",
        md: "19vw",
        lg: "16vw",
        "2xl": "250px",
      }}
      data-cy={"section-sidebar"}
    >
      <VStack align="start" w="full" spacing={4} px={4}>
        {SIDEBAR_OPTIONS.map((item, index) => {
          const { icon, label, value } = item;
          return (
            <Link
              href={`${MAIN_ROUTES.PRICING}?table=${value}`}
              key={index}
              replace={true}
              scroll={false}
            >
              <HStack spacing={4} _hover={{ color: "brand.100" }} py={2}>
                <Icon as={icon} color="brand.200" fontSize="20px" />
                <Text>{label}</Text>
              </HStack>
            </Link>
          );
        })}
      </VStack>
    </Box>
  );
};

export default PricingSidebar;
